import Vue from 'vue'
import socket from 'client/socket'
import config from 'client/config'

const filter = require('lodash/filter')

export default function (store) {
  let state = {
    items: [],
    organisationId: null,
    disciplineId: null,
    formats: [],
    tieBreaks: [],
  };

  const actions = {
    'importTemplates.load': function(ctx, opts) {
      if (! opts.organisationId) {
        console.log('no organisation id')
        return null
      }

      leaveRooms()
      let params = {}
      store.commit('importTemplates.setOrganisationId', opts.organisationId)
      if (opts.disciplineId) {
        store.commit('importTemplates.setDisciplineId', opts.disciplineId)
        params = {
          disciplineId: opts.disciplineId,
        }
      }

      return new Promise((resolve, reject) => Vue.http.get(
        config.root + '/organisations/' + opts.organisationId + '/templates', {params}).then(result => {
          store.commit('importTemplates.setItems', result.data);
          joinRooms()
          Vue.http.get(config.root + '/disciplines/' + opts.disciplineId + '/get-info',
            {params: { organisationId: opts.organisationId}}).then((result) => {
            store.commit('importTemplates.setFormats', result.data.formats)
            store.commit('importTemplates.setTieBreaks', result.data.tieBreaks)
            resolve()
          });
        }, err => reject(err)))
    },
    'importTemplate.update': function(ctx, data) {
      return new Promise((resolve, reject) => Vue.http.patch(config.root + '/importTemplates/' + data.id,
        data).then(result => {
        store.commit('importTemplate.update', result.data);
        resolve(result.data)
      }, err => reject(err)))
    },
    'importTemplate.add': function(ctx, opts) {
      let data = opts.data
      data.organisationId = ctx.state.organisationId
      return new Promise((resolve, reject) =>
        Vue.http.post(config.root + '/organisations/' + data.organisationId + '/importTemplates', data)
          .then((result) => {
            resolve(result.data)
      }, err => reject(err)))
    },
    'importTemplate.remove': function(ctx, opts) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(config.root + '/importTemplates/' + opts.id).then(() => {
          store.commit('importTemplate.remove', opts.id)
          resolve()
        }, err => reject(err))
      })
    },
  };

  function leaveRooms() {
    if (state.eventId) {
      socket.emit('leave', 'importTemplate:' + state.organisationId)
      store.commit("importTemplates.setOrganisationId", undefined)
    }
  }

  function joinRooms() {
    if (state.organisationId) {
      socket.emit('join', 'importTemplate:' + state.organisationId)
    }
  }

  const mutations = {
    'importTemplates.setItems': function(state, items) {
      Vue.set(state, 'items', items)
    },
    'importTemplates.setOrganisationId': function(state, organisationId) {
      Vue.set(state, 'organisationId', organisationId)
    },
    'importTemplates.setDisciplineId': function(state, disciplineId) {
      Vue.set(state, 'disciplineId', disciplineId)
    },
    'importTemplates.setFormats': function(state, items) {
      Vue.set(state, 'formats', items)
    },
    'importTemplates.setTieBreaks': function(state, items) {
      Vue.set(state, 'tieBreaks', items)
    },
    'importTemplate.remove': function(state, id) {
      state.items = filter(state.items, item => item.id !== id )
    },
    'importTemplate.add': function(state, displayTemplate) {
      state.items.push(displayTemplate)
    },
    'importTemplate.update': function(state, item) {
      const index = state.items.findIndex(i => i.id === item.id)
      let templates = state.items
      if (index >= 0) {
        templates.splice(index, 1, item)
      }
      else {
        templates.push(item)
      }

      Vue.set(state, 'items', templates)
    }
  };

  function listener() {
    socket.on('connect', function () {
      joinRooms()
    })
    socket.on('importTemplate.update', function(result) {
      console.log('importTemplate update', result)
      if (state.disciplineId && state.disciplineId !== result.data.disciplineId) {
        return
      }
      store.commit('importTemplate.update', result.data)
    });
    socket.on('importTemplate.delete', result => {
      store.commit('importTemplate.remove', result.data)
    });
    socket.emit('join', 'importTemplate.delete')
  }

  store.registerModule('importTemplates', {
    state: state,
    mutations: mutations,
    actions: actions,
  });

  listener()
}
